module.exports = __webpack_public_path__ + "img/robotics.34699120.png";